<div class="card mb-3">
    <div class="card-body">
        <div class="card-title h4">Events</div>
        <div class="card-text">
            <app-event-list [events]="events"></app-event-list>
        </div>
    </div>
</div>